export default __webpack_public_path__ + "static/media/water_rune.506b27e4.svg";